import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from '../../environments/environment.prod';
import { Title } from '@angular/platform-browser';


@Injectable({
    providedIn: 'root'
})
export class LanguajeGuard implements CanActivate {

    isMatch: boolean;

    constructor(private title: Title) {
    }


    canActivate(): boolean {
        const mapBrand = environment.subdomainBrands;
        this.isPresentUrl(mapBrand);
        if (this.isMatch) {
            return true;
        } else {
            return false;
        }
    }

    isPresentUrl(mapBrand: any) {
        Object.keys(mapBrand).map((key) => {
            if (document.location.host.toLowerCase().includes(mapBrand[key].toLowerCase())) {
                this.isMatch = true;
                this.validateLanguaje(key);
            }
        });
    }

    validateLanguaje(key: string) {
        const defaultlang = environment.configLanguageBrand[key];
        if (defaultlang) {
            sessionStorage.setItem('lang', defaultlang['languageDefault']);
            this.changeTitleForLang(defaultlang['languageDefault']);
        } else {
            let defaultLang = environment.configLanguageBrand.default;
            sessionStorage.setItem('lang', defaultLang);
            this.changeTitleForLang(defaultLang);
        }

    }

    changeTitleForLang(lang: string) {
        if (lang === 'en') {
            this.title.setTitle('Terms and conditions');
        } else if (lang === 'es') {
            this.title.setTitle('Términos y Condiciones');
        }
    }

}
